import { render, staticRenderFns } from "./NDialog.vue?vue&type=template&id=74d478a3"
import script from "./NDialog.vue?vue&type=script&lang=ts"
export * from "./NDialog.vue?vue&type=script&lang=ts"
import style0 from "./NDialog.vue?vue&type=style&index=0&id=74d478a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports